import { useState, useEffect } from 'react';
import { subscriptionApi, PaymentHistoryItem } from '../../api/subscriptionApi';
import SettingsWrapper from './SettingsWrapper';

const STATUS: Record<string, string> = {
    succeeded: 'bg-green-50 text-green-700 border-green-100',
    pending:   'bg-amber-50 text-amber-700 border-amber-100',
    failed:    'bg-red-50 text-red-600 border-red-100',
};

const BillingPage = () => {
    const [history, setHistory] = useState<PaymentHistoryItem[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        subscriptionApi.getPaymentHistory().then(setHistory).catch(() => {}).finally(() => setLoading(false));
    }, []);

    return (
        <SettingsWrapper title="Billing" subtitle="Your payment history">
            <div className="bg-white border border-gray-100 rounded-xl shadow-sm overflow-hidden">
                {loading ? (
                    <div className="p-5 space-y-3">{Array.from({ length: 3 }).map((_, i) => <div key={i} className="h-12 bg-gray-100 rounded-xl animate-pulse"/>)}</div>
                ) : history.length === 0 ? (
                    <div className="py-16 text-center">
                        <div className="w-12 h-12 bg-gray-50 border border-gray-100 rounded-xl flex items-center justify-center mx-auto mb-3">
                            <svg className="text-gray-300" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
                                <line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
                            </svg>
                        </div>
                        <p className="text-sm font-semibold text-gray-500">No payments yet</p>
                    </div>
                ) : (
                    <table className="w-full">
                        <thead><tr className="border-b border-gray-50">
                            <th className="px-5 py-3 text-left text-[10px] font-bold text-gray-400 uppercase">Date</th>
                            <th className="px-5 py-3 text-left text-[10px] font-bold text-gray-400 uppercase">Amount</th>
                            <th className="px-5 py-3 text-left text-[10px] font-bold text-gray-400 uppercase">Status</th>
                        </tr></thead>
                        <tbody className="divide-y divide-gray-50">
                            {history.map(item => (
                                <tr key={item.id} className="hover:bg-gray-50/50">
                                    <td className="px-5 py-3.5 text-[12px] font-semibold text-gray-700">
                                        {new Date(item.createdAt).toLocaleDateString('en-US', { day: '2-digit', month: 'short', year: 'numeric' })}
                                    </td>
                                    <td className="px-5 py-3.5 text-[13px] font-bold text-gray-900">${item.amount.toFixed(2)}</td>
                                    <td className="px-5 py-3.5">
                                        <span className={`text-[10px] font-bold px-2 py-1 rounded-full border capitalize ${STATUS[item.status] || STATUS.pending}`}>{item.status}</span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </SettingsWrapper>
    );
};

export default BillingPage;